import { NotificationStateEnum } from '~/src/models/enums/notification-state.enum';
import { RedirectLinkEnum } from '~/src/models/enums/redirect-link.enum';

export interface CopyTextInterface {
    text: string;
    stateCopyText: NotificationStateEnum;
}

export class AppState {
    redirectLink: RedirectLinkEnum = RedirectLinkEnum.default;
    copyText: CopyTextInterface = {
        text: '',
        stateCopyText: NotificationStateEnum.default,
    };
}
